module.exports = __webpack_public_path__ + "static/media/pulse-power-logo.1474c767.svg";